var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6929 0.292844C15.0834 -0.0976801 15.7166 -0.0976801 16.1071 0.292844C16.4976 0.683369 16.4976 1.31653 16.1071 1.70706L14.6929 0.292844ZM0.292893 1.70706C-0.0976311 1.31653 -0.0976311 0.683369 0.292893 0.292844C0.683417 -0.0976801 1.31658 -0.0976801 1.70711 0.292844L0.292893 1.70706ZM9.26066 7.13929L8.55355 6.43218L9.26066 7.13929ZM1.70711 0.292844L7.84645 6.43218L6.43223 7.8464L0.292893 1.70706L1.70711 0.292844ZM8.55355 6.43218L14.6929 0.292844L16.1071 1.70706L9.96777 7.8464L8.55355 6.43218ZM7.84645 6.43218C8.04171 6.62745 8.35829 6.62745 8.55355 6.43218L9.96777 7.8464C8.99146 8.82271 7.40854 8.82271 6.43223 7.8464L7.84645 6.43218Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.43d593f478d45f79b70767a201cec8da.svg";
export { ForwardRef as ReactComponent };